import React, { Component } from 'react';
import MuiFlatButton from 'material-ui/FlatButton';
import MuiDialog from 'material-ui/Dialog';

import styles from '../../../../shared-styles';
import './index.css';

export default class ConnectModal extends Component {
  constructor(props) {
    super(props);
    this.state = { contactModalOpen: false };
  }

  handleOpenModal = () => {
    this.setState({ contactModalOpen: true });
  }

  handleCloseModal = () => {
    this.setState({ contactModalOpen: false });
  }

  render() {
    return (
      <div className="connect-modal-component">
        <a onClick={ this.handleOpenModal }>Learn More</a>
        <MuiDialog
          className="connect-modal"
          actions={ [
            <MuiFlatButton
              key="got-it-button"
              label="Ok, Got it"
              labelStyle={ styles.dialogLabelStyle }
              style={{ width: '100%' }}
              hoverColor="transparent"
              rippleColor="transparent"
              onClick={ this.handleCloseModal }
            />
          ] }
          style={{ borderRadius: '4px' }}
          bodyStyle={{ borderTop: '0' }}
          contentClassName="modal-content"
          open={ this.state.contactModalOpen }
          onRequestClose={ this.handleCloseModal }
          autoScrollBodyContent={ true }
        >
          <h3>If you answer Yes:</h3>
          <p>You own an iFit wearable that you plan on connecting to the app. Or you just want to use the app on your phone, without connecting a wearable.</p>

          <h3>If you answer No:</h3>
          <p>You don't own an iFit wearable, or you own a different product. Keep in mind, you don't need an iFit wearable to experience iFit. We recommend it, but it's not required. You can still enjoy a personalized fitness experience using just the app.</p>
        </MuiDialog>
      </div>
    );
  }
}